import { render } from "./Archievements.vue?vue&type=template&id=f6057558"
import script from "./Archievements.vue?vue&type=script&lang=js"
export * from "./Archievements.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__